import "../styles/subPassComp.css"

function SubPassComp() {

    return (
        <div>
            
            <h1 id="threeWays">Three Ways to Subscribe</h1>
            <div className="subscriptionTypeContainer">
                {/* <div className="passContainer">
                    <h2>Monthly Pass</h2>
                    <h3 className="accessH3">Access for the month</h3>
                    <h3 id="freeTrial">5 DAY FREE TRIAL FOR NEW MEMBERS</h3>
                    <h3>$20/month</h3>
                    <p id="autoRenew">AUTOMATICALLY RENEWS EACH MONTH</p>
                    <p id="comingMarch">Coming Opening Day (March 25th)</p>
                </div> */}
                <div className="passContainer">
                    <h2>Season Pass</h2>
                    <h3 className="accessH3">Access for the 2026</h3>
                    <h3 id="seasonh3">Postseason</h3>
                    {/* <h3 id="save25">ON SALE Through Sunday July 19th</h3> */}
                    <h3>$10</h3>
                    <p>Does NOT automatically renew</p>
                    <br />
                </div>
                <div className="passContainer">
                    <h2 id="dayPassHeader">Day Pass</h2>
                    <h3 className="accessH3">Access for the Day</h3>
                    <h3>$3</h3>
                    <p>Only buy on days with MLB games</p>
                    <p>NOT A 24 HOUR PASS</p>
                    <p>Does NOT automatically renew</p>
                    <br />
                </div>
            </div>
        </div>
    )
}

export default SubPassComp